import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PlayerPauseIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PlayerPause",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M6.08 2h5.08c.75 0 1.36.61 1.36 1.36v25.28c0 .75-.61 1.36-1.36 1.36H6.08c-.75 0-1.36-.61-1.36-1.36V3.36c0-.75.61-1.36 1.36-1.36m14.76 0h5.08c.75 0 1.36.61 1.36 1.36v25.28c0 .75-.61 1.36-1.36 1.36h-5.08c-.75 0-1.36-.61-1.36-1.36V3.36c0-.75.61-1.36 1.36-1.36"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M19.29 6h3.43v20.57h-3.43z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22.71 27.71h-3.43c-.63 0-1.14-.51-1.14-1.14V6c0-.63.51-1.14 1.14-1.14h3.43c.63 0 1.14.51 1.14 1.14v20.57c0 .63-.51 1.14-1.14 1.14m-2.28-2.28h1.14V7.14h-1.14v18.28ZM9 6h3.43v20.57H9z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.43 27.71H9c-.63 0-1.14-.51-1.14-1.14V6c0-.63.51-1.14 1.14-1.14h3.43c.63 0 1.14.51 1.14 1.14v20.57c0 .63-.51 1.14-1.14 1.14m-2.29-2.28h1.14V7.14h-1.14v18.28Z"
      })]
    })
  }));
};